import React from 'react';

const SkeletonAppEnabled = () => {
    return (
        <main className="w-[100%] pt-[86px]">
            <header className="mb-6 flex mobile:flex-col justify-between desktop:flex-row laptop:flex-row gap-2">
                <div className="flex mobile:items-center gap-10">
                    <div className="animate-pulse bg-gray-200 h-8 w-40 rounded"></div>
                </div>

                <div className="flex mobile:flex-col laptop:flex-row desktop:flex-row  gap-4">
                    <div className="animate-pulse bg-gray-200 h-8 w-[280px] rounded"></div>
                    <div className="animate-pulse bg-gray-200 h-8 w-28 rounded"></div>
                </div>
            </header>


            <main className="w-full">
                <section style={{ width: '100%' }}>
                    <div className="w-full grid laptop:grid-cols-[minmax(0,_2fr)_minmax(0,_1fr)] gap-4">
                        <div className="grid grid-rows-2 gap-4 laptop:grid-rows-[minmax(0,_150px)_minmax(0,_1fr)]">
                            <div className="grid grid-cols-2 gap-4 laptop:grid-cols-4">
                                <div className="animate-pulse bg-gray-200 w-full rounded"/>
                                <div className="animate-pulse bg-gray-200 w-full rounded"/>
                                <div className="animate-pulse bg-gray-200 w-full rounded"/>
                                <div className="animate-pulse bg-gray-200 w-full rounded"/>
                            </div>

                            <div className="grid laptop:grid-cols-2 gap-4">
                                <div className="grid grid-rows-[minmax(0,_150px)_minmax(150px,_1fr)] gap-4">
                                    <div className="animate-pulse bg-gray-200 w-full rounded"/>
                                    <div className="animate-pulse bg-gray-200 w-full rounded"/>
                                </div>
                                
                                <div className="grid laptop:grid-cols-1 gap-4">
                                    <div className="animate-pulse bg-gray-200 w-full rounded"/>
                                </div>
                            </div>
                        </div> 
                        <div className="animate-pulse bg-gray-200 h-54 w-full rounded"/>    
                    </div>
                </section>

                <section className="w-full mt-4 pb-2 overflow-x-auto">
                    <div className="flex items-center gap-10">
                        <div className="animate-pulse bg-gray-200 h-8 w-40 rounded"></div>
                    </div>
                </section>

                <section className="w-full mt-2 pb-2 overflow-x-auto">
                    <div className="grid grid-cols-[repeat(6,minmax(240px,16.66%))] gap-2 h-[260px]">
                        <div className="animate-pulse bg-gray-200 rounded"/> 
                        <div className="animate-pulse bg-gray-200 rounded"/> 
                        <div className="animate-pulse bg-gray-200 rounded"/>    
                        <div className="animate-pulse bg-gray-200 rounded"/>                  
                        <div className="animate-pulse bg-gray-200 rounded"/> 
                        <div className="animate-pulse bg-gray-200 rounded"/> 
                    </div>
                </section>
            </main>
        </main>
    );
};

export default SkeletonAppEnabled;
